<template>
  <div>
    <h2>Pick a day and time:</h2>
    <app-pick-date-time></app-pick-date-time>
  </div>
</template>

<script>
import PickDateTime from "@/components/BookingApp/UserView/PickDateTime";
export default {
  name: "PickATime",
  components: {
    appPickDateTime: PickDateTime,
  },
};
</script>

<style>
</style>